import { render, staticRenderFns } from "./onlineTestAssignStudents.html?vue&type=template&id=4bd3ea13&external"
import script from "./onlineTestAssignStudents.vue?vue&type=script&lang=js"
export * from "./onlineTestAssignStudents.vue?vue&type=script&lang=js"
import style0 from "./onlineTestAssignStudents.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports